import {Component, inject} from '@angular/core';
import {LocaleService} from "../../../../locale/locale.service";
import {AdditionalActionHeaderComponent} from "../additional-action-header/additional-action-header.component";
import {FooterComponent} from "../../../common/footer/footer.component";
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-about-policyholder',
  imports: [
    AdditionalActionHeaderComponent,
    FooterComponent,
    NgOptimizedImage
  ],
  templateUrl: './about-policyholder.component.html',
  styleUrl: './about-policyholder.component.css'
})
export class AboutPolicyholderComponent {
  locale = inject(LocaleService);
}
